<h3 class="contact__header">{{type}}</h3>
<div class="contact__body">
  <div *ngIf="contact.name" class="contact__name">{{contact.name}}</div>
  <app-address *ngIf="contact.address" [address]="contact.address" class="contact__address"></app-address>
  <div *ngIf="contact.phoneNumber" class="contact__phone">
    {{ contact.phoneNumber | phone }}
    <ng-container *ngIf="contact.phoneType">({{ contact.phoneType }})</ng-container>
  </div>
  <div *ngIf="contact.email" class="contact__email">
    {{ contact.email }}
  </div>
  <div class="contact__remarks" *ngIf="remarks.length > 0">
    <div class="contact__remark-label">Remarks:</div>
    <app-remark-list class="contact__remark-list" [remarks]="remarks" [compact]="true"></app-remark-list>
  </div>
</div>
